import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.clickOutside = this.clickOutside.bind(this)
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    Object.assign(this.menuTarget.style, {
      opacity: "0",
      transform: "scale(0.95)",
      transformOrigin: "top right",
      transition: "opacity 150ms cubic-bezier(0.23,1,0.32,1), transform 150ms cubic-bezier(0.23,1,0.32,1)"
    })
    this.menuTarget.offsetHeight
    this.menuTarget.style.opacity = "1"
    this.menuTarget.style.transform = "scale(1)"
    document.addEventListener("click", this.clickOutside)
  }

  close() {
    this.menuTarget.style.opacity = "0"
    this.menuTarget.style.transform = "scale(0.95)"

    if (this.prefersReducedMotion) {
      this.menuTarget.classList.add("hidden")
    } else {
      this.menuTarget.addEventListener("transitionend", () => {
        this.menuTarget.classList.add("hidden")
      }, { once: true })
    }

    document.removeEventListener("click", this.clickOutside)
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutside)
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
